import { Button, Stack, Text, Title, VisuallyHidden } from "@mantine/core";
import { AppWebviewLayout } from "./AppWebviewLayout";
import highFiveUrl from "../../assets/highfive-yellow.svg?url";
import arrowTopRightIconUrl from "../../assets/arrow-top-right-icon.svg?url";
import shared from "./appWebviewShared.module.css";

interface ExistingCustomerAppViewProps {
  title: string;
  description: string;
}

const ExistingCustomerAppView = ({
  title,
  description,
}: ExistingCustomerAppViewProps) => {
  return (
    <AppWebviewLayout
      fillBody
      footer={
        <Button
          size="lg"
          fullWidth
          component="a"
          href={`${window.location.origin}/login`}
          target="_blank"
          rel="noopener noreferrer"
          rightSection={
            <img src={arrowTopRightIconUrl} alt="" width={20} height={20} />
          }
        >
          Gå till Sambla Pension
          <VisuallyHidden> (öppnas i ny flik)</VisuallyHidden>
        </Button>
      }
    >
      <Stack gap="xl" align="center" className={shared.content}>
        <img src={highFiveUrl} alt="" className={shared.doorIcon} />

        <Stack gap="sm" align="center">
          <Title
            order={1}
            fz="h2"
            lh="h2"
            ff="var(--wallet-font-family-sambla-sans)"
            ta="center"
          >
            {title}
          </Title>
          <Text c="dimmed" size="sm" lh={1.6} ta="center">
            {description}
          </Text>
        </Stack>
      </Stack>
    </AppWebviewLayout>
  );
};

export default ExistingCustomerAppView;
